import { useState } from "react";
import { compose } from "redux";

import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";

import { termsConnector } from "../../../services/terms/connector";

import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import SavelendTerms from "./SavelendTerms";
import LoanstepTerms from "./LoanstepTerms";

const TermsComponent = () => {
  const [tab, setTab] = useState(0);

  return (
    <div className="terms-layout body-height">
      <Tabs value={tab}>
        <Tab label={"Savelend terms"} onClick={() => setTab(0)} />
        <Tab label={"Loanstep terms"} onClick={() => setTab(1)} />
      </Tabs>
      {tab === 0 && <SavelendTerms />}
      {tab === 1 && <LoanstepTerms />}
    </div>
  );
};
export default compose(termsConnector)(TermsComponent);
